import React from "react";
import Button from "components/Button";
import { buttonType } from "components/Button/Button";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components/macro";
import { DefaultText } from "theme/GlobalElements";
import SampleProductCard from "./SampleProductCard";
import { selectCartReload, setCurrentStep, updateCartData } from "./cartSlice";
import { ProductCartItem } from "./types";
import { useNavigate } from "react-router-dom";
import { toRem } from "theme/Breakpoints";
import userStorage from "store/UserStorage";
import DualPrice from "components/Price";

interface CartDataProps {
  listedItems: any[];
  removeElementWithId: (id: string) => void;
  emptyMessage: string;
  actionButtonTitle: string;
  actionRoute: string;
  actionButtonIcon?: any;
  onClickOutside?: () => void;
  showCount?: boolean;
}

const CartDropdownData: React.FC<CartDataProps> = ({
  onClickOutside,
  listedItems,
  emptyMessage,
  actionButtonTitle,
  actionRoute,
  actionButtonIcon = <></>,
  removeElementWithId,
  showCount = true,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reload = useSelector(selectCartReload);
  const totalPriceD = userStorage.selectTotalPriceWithDiscount();
  const totalPrice = userStorage.selectTotalPriceWithoutDiscount();

  const checkout = () => {
    showCount && dispatch(setCurrentStep(1));
    navigate(actionRoute);
    onClickOutside && onClickOutside();
  };

  return (
    <CartDataContainer>
      {listedItems.length !== 0 ? (
        listedItems.map((citem, idx) => {
          return (
            <SampleProductCard
              key={idx}
              item={citem}
              removeElemenWithId={removeElementWithId}
            />
          );
        })
      ) : (
        <DefaultText style={{ padding: "10px" }} fontSize={16}>
          {emptyMessage}
        </DefaultText>
      )}
      {showCount && listedItems.length !== 0 && (
        <>
          <Summary>
            <DefaultText fontSize={15}>
              {`Общо без отстъпка:`}
              <strong><DualPrice bgn={totalPrice} /></strong>
            </DefaultText>
            <DefaultText fontSize={15}>
              {`Общо с отстъпка:`}
              <strong><DualPrice bgn={totalPriceD} /></strong>
            </DefaultText>
          </Summary>
        </>
      )}
      {listedItems.length !== 0 && (
        <Button
          onClick={checkout}
          title={actionButtonTitle}
          type={buttonType.blueBtn}
          classNames="dropdown-button"
        >
          {actionButtonIcon}
        </Button>
      )}
    </CartDataContainer>
  );
};

const CartDataContainer = styled.div`
  padding: 5px;
  .dropdown-button {
    margin-top: 5px;
  }
`;
const Summary = styled.div`
  padding: 5px 0;
  width: 100%;
  height: auto;
  text-align: right;
`;

export default CartDropdownData;
